/**
 * Every fetch in this app goes through here so a 401 (no session, or a
 * session for an email that isn't on HELM_ADMIN_EMAILS — see
 * @hub/lib/require-admin) has exactly one place to turn into a redirect. The
 * SPA shell itself is served unauthenticated (see the routing comment in
 * @hub/index) — this is where the real gate bites for a browser.
 */
export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export async function apiFetch<T>(input: string, init?: RequestInit): Promise<T> {
  const res = await fetch(input, {
    ...init,
    headers: { "content-type": "application/json", ...init?.headers },
  });

  if (res.status === 401) {
    window.location.href = "/login";
    // Never resolves — the redirect above is about to tear this page down.
    return new Promise<T>(() => {});
  }

  const body = await res.json().catch(() => null);
  if (!res.ok) {
    const message = (body as { error?: string } | null)?.error ?? `request failed (${res.status})`;
    throw new ApiError(res.status, message);
  }
  return body as T;
}
